var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10525 11.8124C0.494839 11.8124 0 12.3072 0 12.9176V19.5492C0 20.1596 0.494839 20.6544 1.10525 20.6544H7.73677C8.34719 20.6544 8.84203 20.1596 8.84203 19.5492V12.9176C8.84203 12.3072 8.34719 11.8124 7.73677 11.8124H1.10525Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.263 0C12.6526 0 12.1577 0.494839 12.1577 1.10525V7.73677C12.1577 8.34719 12.6526 8.84203 13.263 8.84203H19.8945C20.5049 8.84203 20.9997 8.34719 20.9997 7.73677V1.10525C20.9997 0.494839 20.5049 0 19.8945 0H13.263Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.263 12.1584C12.6526 12.1584 12.1577 12.6533 12.1577 13.2637V19.8952C12.1577 20.5056 12.6526 21.0005 13.263 21.0005H19.8945C20.5049 21.0005 20.9997 20.5056 20.9997 19.8952V13.2637C20.9997 12.6533 20.5049 12.1584 19.8945 12.1584H13.263Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10525 0C0.494839 0 0 0.494839 0 1.10525V7.73677C0 8.34719 0.494839 8.84203 1.10525 8.84203H7.73677C8.34719 8.84203 8.84203 8.34719 8.84203 7.73677V1.10525C8.84203 0.494839 8.34719 0 7.73677 0H1.10525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.960508cc1f540b2ce1edd81e2f77c1c5.svg";
export { ForwardRef as ReactComponent };